export default Object.freeze( [
	"#4285F4",
	"#DB4437",
	"#F4B400",
	"#0F9D58",
	"#AB47BC",
	"#00ACC1",
	"#FF7A43",
	"#9E9D24",
	"#5C6BC0",
	"#F06292",
	"#00796B",
	"#C2185B",
	"#43459D",
	"#53A8FB",
	"#5F9654",
	"#E7711B",
	"#871B47",
	"#4374E0",
	"#1A8763"
] );
